import React from 'react';
import { RxDotsVertical } from 'react-icons/rx';

const ProgressTrackerTable = ({ projects_progress }) => {
    return (
        <div className="overflow-hidden h-full flex flex-col rounded-xl shadow-md bg-white">
            <div className="pb-3 w-full px-6 pt-4 flex items-center justify-between border-b border-gray-100">
                <h3 className="font-semibold text-lg text-gray-900">Project Progress Tracker</h3>
                <button className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100">
                    <RxDotsVertical className="w-5 h-5" />
                </button>
            </div>

            <div className="overflow-x-auto flex-grow px-4 pb-4">
                <table className="min-w-full">
                    <thead>
                        <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <th className="py-3 px-4">Project Name</th>
                            <th className="py-3 px-4">Start Date</th>
                            <th className="py-3 px-4">Status</th>
                            <th className="py-3 px-4">Progress</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {(!projects_progress || projects_progress.length === 0) ? (
                            <tr>
                                <td colSpan="4" className="py-8 px-4 text-center text-gray-500">
                                    No project data available.
                                </td>
                            </tr>
                        ) : (
                            projects_progress.map((project) => (
                                <tr key={project.id} className="text-sm text-gray-800">
                                    <td className="py-4 px-4 whitespace-nowrap font-medium">{project.title}</td>
                                    <td className="py-4 px-4 whitespace-nowrap text-gray-600">{project.start_date}</td>
                                    <td className="py-4 px-4 whitespace-nowrap">
                                        <span
                                            className={`px-3 py-1 text-xs font-medium rounded-full ${project.status === 'not_started'
                                                    ? 'bg-gray-100 text-gray-600 border border-gray-200'
                                                    : project.status === 'in_progress'
                                                        ? 'bg-yellow-50 text-yellow-600 border border-yellow-200'
                                                        : project.status === 'completed'
                                                            ? 'bg-green-50 text-green-600 border border-green-200'
                                                            : project.status === 'on_hold'
                                                                ? 'bg-red-50 text-red-600 border border-red-200'
                                                                : 'bg-gray-100 text-gray-600'
                                                }`}
                                        >
                                            {project.status.replace('_', ' ')}
                                        </span>
                                    </td>
                                    <td className="py-4 px-4 whitespace-nowrap">
                                        <div className="w-full">
                                            <div className="flex justify-between items-center mb-2 text-xs font-medium">
                                                <span className="text-gray-700">{project.progress}%</span>
                                            </div>
                                            <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
                                                <div
                                                    className={`h-2 rounded-full ${project.progress < 30
                                                            ? 'bg-red-500'
                                                            : project.progress < 70
                                                                ? 'bg-yellow-500'
                                                                : 'bg-green-500'
                                                        }`}
                                                    style={{ width: `${project.progress}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProgressTrackerTable;